// extracted by mini-css-extract-plugin
export var close = "index-module--close--aAi0W";
export var content = "index-module--content--G-Qsm";
export var maxLg = "(max-width: 67.625em)";
export var modal = "index-module--modal--EK49j";
export var modalBody = "index-module--modalBody--PMk2r";